import { inject, MaybeRefOrGetter, toValue } from "vue";
import { RouteLocationRaw, routerKey } from "vue-router";

export type HostNavigationMode = "vue" | "mvc";

type UseHostNavigationOptions = {
  navigationMode?: MaybeRefOrGetter<HostNavigationMode>;
  vueBaseUrl?: MaybeRefOrGetter<string>;
};

const DEFAULT_NAVIGATION_MODE: HostNavigationMode = "vue";
const DEFAULT_VUE_BASE_URL = "/v2/#";

function normalizeBaseUrl(baseUrl: string) {
  return baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
}

export default function useHostNavigation(
  options: UseHostNavigationOptions = {}
) {
  const router = inject(routerKey, null);

  function getNavigationMode() {
    return toValue(options.navigationMode) ?? DEFAULT_NAVIGATION_MODE;
  }

  function getVueBaseUrl() {
    return toValue(options.vueBaseUrl) ?? DEFAULT_VUE_BASE_URL;
  }

  function buildVueUrl(fullPath: string) {
    return `${normalizeBaseUrl(getVueBaseUrl())}${fullPath}`;
  }

  function navigateTo(routeLocation: RouteLocationRaw) {
    if (getNavigationMode() === "mvc") {
      if (router) {
        const resolvedRoute = router.resolve(routeLocation);
        window.location.href = buildVueUrl(resolvedRoute.fullPath);
      }

      return;
    }

    return router?.push(routeLocation);
  }

  return {
    buildVueUrl,
    navigateTo
  };
}
